import Layout from '@/layout';
import CloudServerRouter from '../../../cloudserver/router/index.js';

export default CloudServerRouter(Layout, 'pc');
